import { render } from "./toDoTaskItem.vue?vue&type=template&id=05dd9b96&ts=true"
import script from "./toDoTaskItem.vue?vue&type=script&lang=ts"
export * from "./toDoTaskItem.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__